export default __webpack_public_path__ + "static/media/sliderActive.f6ddb42d.svg";